import React from 'react';
import {RaRecord, useRecordContext} from 'react-admin';

import {Typography, TypographyProps} from '@mui/material';

import {getByPath} from '../../../utils/record.helper';

type Props = {
    component?: string;
    source: string;
    startAdorment?: string;
    recordLocal?: RaRecord;
} & TypographyProps;

export const EmptyText = React.memo(({recordLocal, source, startAdorment, ...props}: Props) => {
    const record = useRecordContext();

    if (!record) return null;

    const field = getByPath(recordLocal || record, source);

    return (
        <Typography {...props}>
            {field
                ? `${startAdorment || ''}${field}`
                : '/'
            }
        </Typography>
    );
});
